export default "__VITE_ASSET__D8A5xZYf__"